import { render, staticRenderFns } from "./production-cell-premium-personal-account.vue?vue&type=template&id=8dece552&scoped=true&"
import script from "./production-cell-premium-personal-account.vue?vue&type=script&lang=js&"
export * from "./production-cell-premium-personal-account.vue?vue&type=script&lang=js&"
import style0 from "./production-cell-premium-personal-account.vue?vue&type=style&index=0&id=8dece552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dece552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dece552')) {
      api.createRecord('8dece552', component.options)
    } else {
      api.reload('8dece552', component.options)
    }
    module.hot.accept("./production-cell-premium-personal-account.vue?vue&type=template&id=8dece552&scoped=true&", function () {
      api.rerender('8dece552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/production-cell-premium-personal-account.vue"
export default component.exports